var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAog136Xxx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 802.12,
    height: 267.37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4",
    fill: "none",
    d: "M178.39 2.15h802.12v267.37H178.39z"
  })), /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fff}.cls-4{fill:#ed1c24}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    id: "g57",
    transform: "translate(-178.39 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon9",
    d: "M707.37 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon11",
    d: "M751.58 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon13",
    d: "M795.79 0H840l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon15",
    d: "M840 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon17",
    d: "M884.21 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon19",
    d: "M928.42 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon21",
    d: "M972.63 0h44.21l181.81 270.94h-44.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon23",
    d: "M353.68 0h44.22l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon25",
    d: "M397.9 0h44.21l181.8 270.94H579.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon27",
    d: "M442.11 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon29",
    d: "M486.32 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon31",
    d: "M530.53 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon33",
    d: "M574.74 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon35",
    d: "M618.95 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon37",
    d: "M663.16 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon39",
    d: "M0 0h44.21l181.8 270.94H181.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon41",
    d: "M44.21 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon43",
    d: "M88.42 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon45",
    d: "M132.63 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon47",
    d: "M176.84 0h44.21l181.8 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon49",
    d: "M221.05 0h44.21l181.81 270.94h-44.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    id: "polygon51",
    d: "M265.26 0h44.21l181.81 270.94h-44.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "polygon53",
    d: "M309.47 0h44.21l181.81 270.94h-44.21z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAog136Xxx);
export default __webpack_public_path__ + "static/media/AOG136XXX.964d3e6453b6b643ce337c7f6267fbe9.svg";
export { ForwardRef as ReactComponent };